import { LegalLayout, LegalSection, PH } from "../components/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" path="/mentions-legales" testid="page-mentions-legales">
      <LegalSection n="1" title="Éditeur du site">
        <p>Le site StreatEat (ci-après « le Site ») est édité par :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Dénomination sociale : <PH>NOM DE LA SOCIÉTÉ</PH></li>
          <li>Forme juridique : <PH>SAS / SARL / EI…</PH></li>
          <li>Capital social : <PH>MONTANT</PH> €</li>
          <li>Siège social : <PH>ADRESSE COMPLÈTE</PH></li>
          <li>RCS / SIRET : <PH>NUMÉRO</PH></li>
          <li>N° TVA intracommunautaire : <PH>FRXX XXXXXXXXX</PH></li>
          <li>E-mail : <PH>contact@streateat.com</PH></li>
          <li>Téléphone : <PH>NUMÉRO</PH></li>
        </ul>
      </LegalSection>

      <LegalSection n="2" title="Directeur de la publication">
        <p>Le directeur de la publication est <PH>PRÉNOM NOM</PH>, en qualité de <PH>FONCTION</PH>.</p>
      </LegalSection>

      <LegalSection n="3" title="Hébergement">
        <p>Le Site est hébergé par :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Hébergeur : <PH>NOM DE L'HÉBERGEUR</PH></li>
          <li>Adresse : <PH>ADRESSE DE L'HÉBERGEUR</PH></li>
          <li>Contact : <PH>SITE / TÉLÉPHONE</PH></li>
        </ul>
      </LegalSection>

      <LegalSection n="4" title="Propriété intellectuelle">
        <p>L'ensemble des contenus du Site (marque « StreatEat », logo, textes, éléments graphiques, code) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de l'éditeur, sauf mention contraire. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable, est interdite.</p>
        <p>Les photos et informations des fiches foodtrucks sont publiées sous la responsabilité de leurs gérants respectifs.</p>
      </LegalSection>

      <LegalSection n="5" title="Contact">
        <p>Pour toute question, vous pouvez nous écrire à <PH>contact@streateat.com</PH>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
